import React, { createContext, useReducer } from 'react';
import Reducer from './reducer';

const initialState = {};

const ActivityStoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return <ActivityContext.Provider value={[state, dispatch]}>{children}</ActivityContext.Provider>;
};

export const ActivityContext = createContext(initialState);
export const ActivityInitialState = initialState;
export default ActivityStoreProvider;
